import { useFormatNumber } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { BTLCalcAccordionBlock } from './BTLCalcAccordionBlock'
import {
  FIELD_PROPS,
  formatOptionsDecimal0,
  formatOptionsDecimal2,
  HorizontalLine2,
  SimpleInputSmallMargin,
} from './BTLCalcUtil'

export const BTLCalcBlock3: FunctionComponent<React.PropsWithChildren<{
  appreciateValue: number
  rentalIncrease: number
  maintenanceValue: number
  maintenanceCosts: number
}>> = (props) => {
  const {
    appreciateValue,
    rentalIncrease,
    maintenanceValue,
    maintenanceCosts,
  } = props

  const formatAbsolute = useFormatNumber(formatOptionsDecimal0)
  const formatPercentage = useFormatNumber(formatOptionsDecimal2)

  return (
    <BTLCalcAccordionBlock title={'Critical Assumptions'}>
      <div tw="flex flex-row pt-px-12 font-size[16px]">
        <div tw="flex-1">
          <SimpleInputSmallMargin
            label={'Appreciation'}
            value={formatPercentage(appreciateValue) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div tw="flex-1">
          <SimpleInputSmallMargin
            label={'Rental increase'}
            value={formatPercentage(rentalIncrease) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>
      <div tw="flex flex-row font-size[16px]">
        <div tw="flex-1 mt-px-20">
          <SimpleInputSmallMargin
            label={'Monthly Hausgeld'}
            value={formatAbsolute(maintenanceValue) + ' EUR'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'numeric' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>

      <HorizontalLine2 />
      <div tw="mt-px-20 font-size[16px]">
        Maintenance Costs
        <br />
        <span tw="font-weight[600]">
          {formatPercentage(maintenanceCosts) + '%'}
        </span>
      </div>
    </BTLCalcAccordionBlock>
  )
}
